import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_WORK_SPACE_ID: createActionType(FULL_NAMESPACE, "SET_WORK_SPACE_ID"),
    SET_NEW_WORK_SPACE: createActionType(FULL_NAMESPACE, "SET_NEW_WORK_SPACE"),
    SET_DRAFT: createActionType(FULL_NAMESPACE, "SET_DRAFT"),
    GET_WORK_SPACE: createActionType(FULL_NAMESPACE, "GET_WORK_SPACE"),
    GET_WORK_SPACE_COMPLETED: createActionType(FULL_NAMESPACE, "GET_WORK_SPACE_COMPLETED"),
    SAVE_WORK_SPACE: createActionType(FULL_NAMESPACE, "SAVE_WORK_SPACE"),
    SAVE_WORK_SPACE_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_WORK_SPACE_COMPLETED")
};
